import request from '@/utils/request'

/**
 * 添加商品到购物车
 * @param {Object} data - 购物车数据
 * @param {number} data.productId - 必填，商品ID
 * @param {number} data.quantity - 必填，数量，必须大于0
 * @param {number} data.productType - 选填，商品类型 1-普通商品 2-积分商品
 * @param {string} data.productName - 选填，商品名称
 * @param {string} data.productImage - 选填，商品图片URL
 * @param {number} data.skuId - 选填，商品规格ID
 * @param {string} data.skuSpec - 选填，SKU规格信息，JSON格式
 * @param {number} data.price - 选填，商品单价
 * @param {number} data.pointsPrice - 选填，积分单价
 * @param {number} data.selected - 选填，是否选中 0-未选中 1-已选中 默认1
 * @returns {Promise}
 */
export function addToCart(data) {
    return request({
        url: '/shop/cart/add',
        method: 'post',
        data
    })
}

/**
 * 获取购物车列表
 * @returns {Promise}
 */
export function getCartList() {
    return request({
        url: '/shop/cart/list',
        method: 'get'
    })
}

/**
 * 更新购物车商品
 * @param {Object} data - 更新数据
 * @param {number} data.id - 必填，购物车ID
 * @param {number} data.quantity - 必填，数量，必须大于0
 * @param {number} data.productType - 选填，商品类型 1-普通商品 2-积分商品
 * @param {string} data.productName - 选填，商品名称
 * @param {string} data.productImage - 选填，商品图片URL
 * @param {number} data.skuId - 选填，商品规格ID
 * @param {string} data.skuSpec - 选填，SKU规格信息，JSON格式
 * @param {number} data.price - 选填，商品单价
 * @param {number} data.pointsPrice - 选填，积分单价
 * @param {number} data.selected - 选填，是否选中 0-未选中 1-已选中
 * @returns {Promise}
 */
export function updateCartItem(data) {
    return request({
        url: '/shop/cart',
        method: 'put',
        data
    })
}

/**
 * 删除购物车商品
 * @param {number|string} ids - 购物车商品ID，多个用逗号分隔，如 1,2,3
 * @returns {Promise}
 */
export function deleteCartItem(ids) {
    return request({
        url: `/shop/cart/${ids}`,
        method: 'delete'
    })
}

/**
 * 计算多商品运费
 * @param {Object} data - 运费计算参数
 * @param {number[]} data.cartIds - 购物车ID列表
 * @param {string} data.receiveAreaCode - 收货地区编码（6位国标）
 * @returns {Promise}
 */
export function calculateFreight(data) {
    return request({
        url: '/shop/freight/api/calculate/multi',
        method: 'post',
        data
    })
}

/**
 * 计算单商品运费
 * @param {Object} data - 运费计算参数
 * @param {number} data.productId - 商品ID
 * @param {number} data.skuId - SKU ID（可选）
 * @param {number} data.quantity - 购买数量
 * @param {string} data.receiveAreaCode - 收货地区编码（6位国标）
 * @returns {Promise}
 */
export function calculateSingleFreight(data) {
    return request({
        url: '/shop/freight/api/calculate/single',
        method: 'post',
        data
    })
}
